import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentStore } from '../../hooks/useCurrentStore';
import BookingLinkShare from '../../components/BookingLinkShare';

const BookingLinkPage: React.FC = () => {
  const { t } = useTranslation(['pages', 'translation']);
  const { storeId, storeInfo } = useCurrentStore();

  if (!storeId) {
    return (
      <div className="container mx-auto px-4 md:px-10 py-6 pb-32">
        <div className="text-center py-12 text-gray-500 dark:text-gray-400">
          {t('pages:admin.bookingLink.loading')}
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 md:px-10 py-6 pb-32">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          {t('pages:admin.bookingLink.title')}
        </h1>
      </div>

      <BookingLinkShare storeId={storeId} storeName={storeInfo?.name} />
    </div>
  );
};

export default BookingLinkPage;
